// extracted by mini-css-extract-plugin
export default {"header":"header_header__OxEJh","line":"header_line__eryjA"};